import { render, staticRenderFns } from "./EvolutionOfWorkload.vue?vue&type=template&id=04b76378"
import script from "./EvolutionOfWorkload.vue?vue&type=script&lang=js"
export * from "./EvolutionOfWorkload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04b76378')) {
      api.createRecord('04b76378', component.options)
    } else {
      api.reload('04b76378', component.options)
    }
    module.hot.accept("./EvolutionOfWorkload.vue?vue&type=template&id=04b76378", function () {
      api.rerender('04b76378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/chart/EvolutionOfWorkload.vue"
export default component.exports